module.exports = __webpack_public_path__ + "img/coupon_bg_1.b62319bd.png";